import { ApiAuthType } from '@pib/api';
export const getLoginUrl = (config) => {
    var _a;
    const redirectUri = config.redirectUrl;
    // For local development only
    // const redirectUri = 'https://localhost:3000/login';
    if (config.type === ApiAuthType.ActiveDirectoryFederationServices) {
        const params = new URLSearchParams();
        params.append('response_type', 'code');
        params.append('client_id', config.clientId);
        params.append('resource', config.resource);
        params.append('redirect_uri', redirectUri);
        if (config.scopes) {
            params.append('scope', config.scopes);
        }
        return `${config.authorizeUrl}?${params.toString()}`;
    }
    if (config.type === ApiAuthType.AzureActiveDirectory ||
        config.type === ApiAuthType.Okta ||
        config.type === ApiAuthType.ItsMe) {
        const params = new URLSearchParams();
        params.append('response_type', 'code');
        params.append('client_id', config.clientId);
        params.append('redirect_uri', redirectUri);
        params.append('response_mode', 'query');
        if ((_a = config.scopes) === null || _a === void 0 ? void 0 : _a.length) {
            params.append('scope', config.scopes);
        }
        if (config.type === ApiAuthType.Okta) {
            params.append('state', config.clientId);
        }
        return `${config.authorizeUrl}?${params.toString()}`;
    }
    throw Error('Unsupported auth type');
};
